

// import React, { useEffect, useState } from "react";

// function ViewStats() {
//   const api_url = "/api";
//   const [views, setViews] = useState([]);
//   const [selectedDate, setSelectedDate] = useState("");

//   async function getViews() {
//     try {
//       const response = await fetch(`${api_url}/getViews`);
//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || "Failed to fetch views");
//       }

//       setViews(data.views);
//     } catch (error) {
//       console.error("Failed to fetch views:", error);
//     }
//   }

//   useEffect(() => {
//     getViews();
//   }, []);

//   // Count page views
//   const homeViews = views?.filter(view => view.type === "HomePage").length;
//   const paymentViews = views?.filter(view => view.type === "PaymentPage").length;
//   const cartViews = views?.filter(view => view.type === "cartPage").length;
//   const products = views?.filter(view =>view.type === "ProductPage").length;

//   // Count product views
//   const productViews = {};

//   views.forEach(view => {
//     if (view.type === "ProductPage") {
//       productViews[view.name] = (productViews[view.name] || 0) + 1;
//     }
//   });

//   return (
//     <div className="flex one column gap">

//       <div className="flex one center">
//         <div className="flex one center">Home Page</div>
//         <div className="flex one center">{homeViews}</div>
//       </div>

//       <div className="flex one center">
//         <div className="flex one center">Payment Page</div>
//         <div className="flex one center">{paymentViews}</div>
//       </div>

//       <div className="flex one center">
//         <div className="flex one center">Cart Page</div>
//         <div className="flex one center">{cartViews}</div>
//       </div>

//       <div className="flex five column overflow">
//         <h3 className="center">Product Views</h3>

//         {Object.keys(productViews).length === 0 ? (
//           <div className="center">No product views </div>
//         ) : (
//           Object.entries(productViews).map(([product, count]) => (
//             <div className="flex one center" key={product}>
//               <div className="flex one center">{product}</div>
//               <div className="flex one center">{count}</div>
//             </div>
//           ))
//         )}
//       </div>

//     </div>
//   );
// }

// export default ViewStats;

import React, { useEffect, useMemo, useState } from "react";

function ViewStats() {
  const api_url = "/api";

  const [views, setViews] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  async function getViews() {
    try {
      const response = await fetch(`${api_url}/getViews`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch views");
      }

      // Handles either { views: [...] } or [...]
      setViews(data.views || data);
    } catch (error) {
      console.error("Failed to fetch views:", error);
    }
  }

  useEffect(() => {
    getViews();
  }, []);

  // Convert any timestamp format into a Date
  const getDate = (viewedAt) => {
    if (!viewedAt) return null;

    // Firestore Timestamp object
    if (viewedAt.seconds) {
      return new Date(viewedAt.seconds * 1000);
    }

    // Firestore Timestamp with toDate()
    if (typeof viewedAt.toDate === "function") {
      return viewedAt.toDate();
    }

    // ISO string or normal date string
    return new Date(viewedAt);
  };

  // Filter views by selected date
  const filteredViews = useMemo(() => {
    if (!selectedDate) return views;

    return views.filter((view) => {
      const date = getDate(view.viewedAt);

      if (!date || isNaN(date)) return false;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}` === selectedDate;
    });
  }, [views, selectedDate]);

  // Page counts
  const homeViews = filteredViews.filter(
    (view) => view.type === "HomePage"
  ).length;

  const paymentViews = filteredViews.filter(
    (view) => view.type === "PaymentPage"
  ).length;

  const cartViews = filteredViews.filter(
    (view) => view.type === "cartPage"
  ).length;

  // Product counts
  const productViews = {};

  filteredViews.forEach((view) => {
    if (view.type === "ProductPage" && view.name) {
      productViews[view.name] = (productViews[view.name] || 0) + 1;
    }
  });

  return (
    <div className="flex one column gap" style={{ padding: "20px" }}>
      {/* Date Filter */}
      <div className="flex one center gap">
        <label>Select Date:</label>

        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />

        <button onClick={() => setSelectedDate("")}>
          Show All
        </button>
      </div>

      <div className="flex one center">
        <strong>
          {selectedDate
            ? `Showing views for ${selectedDate}`
            : "Showing all views"}
        </strong>
      </div>

      {/* Home */}
      <div className="flex one center">
        <div className="flex one center">Home Page</div>
        <div className="flex one center">{homeViews}</div>
      </div>

      {/* Payment */}
      <div className="flex one center">
        <div className="flex one center">Payment Page</div>
        <div className="flex one center">{paymentViews}</div>
      </div>

      {/* Cart */}
      <div className="flex one center">
        <div className="flex one center">Cart Page</div>
        <div className="flex one center">{cartViews}</div>
      </div>

      {/* Products */}
      <div className="flex five column overflow">
        <h3 className="center">Product Views</h3>

        {Object.keys(productViews).length === 0 ? (
          <div className="center">No product views</div>
        ) : (
          Object.entries(productViews)
            .sort((a, b) => b[1] - a[1])
            .map(([product, count]) => (
              <div
                className="flex one center"
                key={product}
                style={{
                  padding: "8px 0",
                  borderBottom: "1px solid #ddd",
                }}
              >
                <div className="flex three">{product}</div>
                <div className="flex one center">{count}</div>
              </div>
            ))
        )}
      </div>
    </div>
  );
}

export default ViewStats;